import { useState } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import NoticeTab from './components/NoticeTab';
import GalleryTab from './components/GalleryTab';

const faqs = [
  { q: '수강료는 얼마인가요?', a: '전 과정(Level 1 기초반 ~ Level 3 마스터반) 통합 수강료는 300만원입니다. 분할 납부 상담도 가능하오니 무료 상담을 통해 문의해 주세요.' },
  { q: '교육 기간은 얼마나 되나요?', a: '총 12주 과정으로, 주 2회 · 회당 2시간 수업으로 진행됩니다. 총 48시간이며 Level 1(기초반, 1~4주) → Level 2(심화반, 5~8주) → Level 3(마스터반, 9~12주) 순서로 단계적으로 진행됩니다.' },
  { q: '자격증은 어떻게 취득하나요?', a: '12주 전 과정 수료 후 본회에서 주관하는 자격증 시험에 응시하실 수 있습니다. 시험 합격 시 2025년 8월부터 임시자격증이 발급될 예정이며, 이후 정식 자격증으로 전환됩니다.' },
  { q: '임시자격증은 무엇인가요?', a: '2025년 8월부터 시험 합격자에게 발급되는 자격증입니다. 임시자격증도 대한문신사중앙회 공식 인증으로, 전문가로서 활동하는 데 활용하실 수 있습니다.' },
  { q: '초보자도 수강 가능한가요?', a: '네, 전혀 경험이 없는 초보자도 수강 가능합니다. Level 1 기초반부터 체계적으로 교육하며, 수강생 수준에 맞춘 1:1 맞춤 지도를 제공합니다.' },
  { q: '위생교육은 별도로 받아야 하나요?', a: '문신사 영업을 위해 필수인 위생교육을 지부에서 직접 이수하실 수 있습니다. 교육 수료 후 이수증이 발급되며, 이는 영업 신고 시 필요한 서류입니다.' },
];

type TabType = 'notice' | 'gallery' | 'faq';

export default function CommunityPage() {
  const [activeTab, setActiveTab] = useState<TabType>('notice');
  const [openFaq, setOpenFaq] = useState<number | null>(null);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main className="pt-20">
        <section className="relative h-72 md:h-96 lg:h-[480px] flex items-center justify-center overflow-hidden">
          <img
            src="https://public.readdy.ai/ai/img_res/5cbbbffb860d56aa1a751d250a6419b5.jpg"
            alt="커뮤니티"
            className="absolute inset-0 w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-black/60" />
          <div className="relative z-10 text-center">
            <div className="page-hero-badge flex items-center justify-center gap-2 mb-3">
              <span className="w-6 h-px bg-[#C9A84C]" />
              <span className="text-[#C9A84C] text-xs font-bold tracking-widest uppercase">Community</span>
              <span className="w-6 h-px bg-[#C9A84C]" />
            </div>
            <h1 className="page-hero-title text-4xl md:text-5xl font-black text-white">커뮤니티</h1>
          </div>
        </section>

        <div className="bg-[#F4F6FA] border-b border-gray-200">
          <div className="max-w-7xl mx-auto px-6 py-3 flex items-center gap-2 text-xs text-gray-500">
            <i className="ri-home-line" /><span>홈</span>
            <i className="ri-arrow-right-s-line" />
            <span className="text-[#1B3A6B] font-semibold">커뮤니티</span>
          </div>
        </div>

        <section className="py-16 bg-white">
          <div className="max-w-5xl mx-auto px-6">
            <div className="flex gap-1 bg-[#F4F6FA] rounded-md p-1 mb-12 w-fit mx-auto border border-gray-200 anim-fade-up is-visible">
              {([['notice', '공지사항'], ['gallery', '갤러리'], ['faq', 'FAQ']] as [TabType, string][]).map(([key, label]) => (
                <button
                  key={key}
                  onClick={() => setActiveTab(key)}
                  className={`whitespace-nowrap px-6 py-2 rounded-sm text-sm font-semibold transition-all cursor-pointer ${activeTab === key ? 'bg-[#1B3A6B] text-white' : 'text-gray-500 hover:text-[#1B3A6B]'}`}
                >
                  {label}
                </button>
              ))}
            </div>

            {activeTab === 'notice' && <NoticeTab />}

            {activeTab === 'gallery' && <GalleryTab />}

            {activeTab === 'faq' && (
              <div className="space-y-2">
                {faqs.map((faq, i) => (
                  <div key={i} className="border border-gray-100 rounded-lg overflow-hidden">
                    <button
                      onClick={() => setOpenFaq(openFaq === i ? null : i)}
                      className="w-full flex items-center justify-between px-6 py-4 text-left cursor-pointer hover:bg-[#F4F6FA] transition-colors"
                    >
                      <span className="text-gray-800 text-sm font-semibold pr-4">{faq.q}</span>
                      {openFaq === i
                        ? <i className="ri-subtract-line text-[#C9A84C] flex-shrink-0" />
                        : <i className="ri-add-line text-[#1B3A6B] flex-shrink-0" />
                      }
                    </button>
                    {openFaq === i && (
                      <div className="px-6 pb-5 bg-[#F4F6FA] border-t border-gray-100">
                        <p className="text-gray-600 text-sm leading-relaxed pt-4">{faq.a}</p>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            )}
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
